/* unplugin-vue-components disabled */import script from "./ingred-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ingred-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./ingred-dialog.vue?vue&type=style&index=0&id=0a7e1150&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7e1150"]])

export default __exports__